import mixins from 'vue-typed-mixins'
import UserActionMixin from '@/mixins/UserActionMixin'
import Call from '@/api/call'

let disabledMakeCallButton = false

export default mixins(UserActionMixin).extend({
  data() {
    return {
      makecallLoading: null
    }
  },
  methods: {
    /**
     * 音声通話発信
     */
    async $_makeCall(id: string, profile: any, type: string) {
      if (disabledMakeCallButton) {
        return
      }
      disabledMakeCallButton = true

      if (this.$_hasCordova) {
        let typeLabel
        if (type === 'voice') {
          typeLabel = '音声通話'
        } else if (type === 'video') {
          typeLabel = 'ビデオ通話'
        } else if (type === 'nozoki') {
          typeLabel = 'のぞき通話'
        }
        let message = `${typeLabel}で発信します`
        let buttonLabels = ['キャンセル', '発信する']
        if (
          (type === 'voice' && !profile.voice_waiting) ||
          (type === 'video' && !profile.video_waiting) ||
          (type === 'nozoki' && !profile.nozoki_waiting)
        ) {
          message = `${
            profile.name
          }さんは現在${typeLabel}ができません。\n無料でリクエストしてお誘いしましょう。`
          buttonLabels = ['キャンセル', 'リクエスト']
        }
        const buttonIndex = await this.$_confirm(message, '', buttonLabels)
        if (!this.$_clickedConfirmOK(buttonIndex)) {
          disabledMakeCallButton = false
          return
        }
        if (!profile.imageURL) {
          profile.imageURL = profile.image_url
        }
        this.$__makeCallWrapper(id, profile.name, profile.imageURL, type)
        // Web ならアプリに遷移
      } else {
        this.$_tryLaunchApp('user/' + id)
      }
      setTimeout(() => {
        disabledMakeCallButton = false
      }, 1000)
    },

    /**
     * entry から $_makeCall に必要な profile プロパティを生成
     */
    $_getProfileFromEntry(entry: any): any {
      return {
        name: entry.name,
        imageURL: entry.profile_image_url,
        voice_waiting: entry.voice_waiting,
        video_waiting: entry.video_waiting,
        nozoki_waiting: entry.nozoki_waiting
      }
    },

    /**
     * 電話発信処理
     */
    async $__makeCallWrapper(id: string, name: string, imageURL: string, type: string) {
      this.makecallLoading = this.$loading.open({
        canCancel: true
      })
      try {
        const data = await Call.makeCall({
          type: type,
          other_id: id
        })
        const error = data.error
        if (error) {
          if (error.code === 9) {
            this.$_showPointBuyDialog(error.message, '')
          } else if (error.code === 20) {
            this.$_ageAuth(error)
          } else {
            this.$_alert(error.message)
          }
          this.makecallLoading.close()
          return
        }
        this.makecallLoading.close()
        this.$router.push({
          name: 'call',
          params: {
            type: type,
            user_id: id,
            name: name,
            profile_image_url: imageURL,
            makecall: '1',
            api_key: data.api_key,
            session_id: data.session_id,
            token: data.token,
            can_phone_call_time: data.can_phone_call_time,
            log_no: data.log_no
          }
        })
      } catch (err) {
        this.makecallLoading.close()
        console.error(err)
        this.$_alert('発信に失敗しました')
      }
    },

    /**
     * AmataCWUserListeItem の通話ボタンをクリックしたときの handler
     */
    $_handleClickCallUserListItem(userData: any, type: string) {
      this.$_makeCall(userData.id, this.$_getProfileFromEntry(userData), type)
    }
  }
})
